import React, { useState } from 'react';
import classNames from 'classnames';
import { BasicSlider, useBasicSlider } from '../BasicSlider/BasicSlider';
/**
 * Bronson [CardsSlider](https://bronson.vwfs.io/bluelabel/components/detail/bronson-cards-slider.html)
 * component provides a space-saving way for adding an arbitrary
 * number of cards. If the number of cards exceeds the horizontal space,
 * a carousel slider is automatically created. This gives the user
 * the possibility to reach all available cards by sliding horizontally.
 */
export function CardsSlider({ className, cellAlign = 'left', groupCells = true, children, testId, ...otherProps }) {
    const initialResizeThreshold = 300;
    const [flickityRef, setFlickityRef] = useState(null);
    useBasicSlider(flickityRef, children, { initialResizeThreshold });
    const flickityOptions = {
        cellSelector: '.c-cards-slider__item',
        pageDots: true,
        prevNextButtons: true,
        groupCells,
        cellAlign,
        contain: false,
        freeScroll: true,
    };
    const classNameList = classNames('c-cards-slider-container', className).trim();
    const flickityClassNameList = classNames('c-cards-slider').trim();
    return (React.createElement("div", { className: classNameList, "data-testid": testId, ...otherProps },
        React.createElement(BasicSlider, { elementType: "div", className: flickityClassNameList, flickityRef: (c) => setFlickityRef(c), options: flickityOptions, onReady: (c) => c?.element?.parentElement?.classList.add('is-initialized') }, children)));
}
CardsSlider.displayName = 'CardsSlider';
/**
 * The CardsSliderItem component is used to wrap
 * the item content and display it inside the {@link CardsSlider}.
 */
export function CardsSliderItem({ className, children, testId, ...otherProps }) {
    const classNameList = classNames('c-cards-slider__item', className).trim();
    return (React.createElement("div", { className: classNameList, "data-testid": testId, ...otherProps },
        React.createElement("div", { className: "c-cards-slider__card-wrapper" }, children)));
}
CardsSliderItem.displayName = 'CardsSlider.Item';
CardsSlider.Item = CardsSliderItem;
